import { CARD_TITLE_COLORS } from '../constants/cardTitleColors';
import styles from '../RecommendedForYou.module.css';

// Background image classes available to Tiny+ upsell card placements.
export const TINY_PLUS_UPSELL_IMAGES = {
  consult: styles.upsellConsult,
  graph: styles.graph,
  kit: styles.order,
} as const;

// Shared visual config for the Tiny+ upsell card, reused by the homepage
// "Recommended for you" card and the contextual placements added in ENG-4426.
// Consumers supply their own `clickable`, `analyticsEventName`, and `onClick`.
export const getTinyPlusUpsellCard = (
  title: string,
  label: JSX.Element,
  imgStyles?: string,
) => {
  return {
    title,
    label,
    imgStyles: imgStyles ?? styles.upsellConsult,
    cardColor: styles.colorUpsellConsult,
    titleColor: CARD_TITLE_COLORS.yellow,
    buttonColor: 'yellow-500' as const,
  };
};
